import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import rank from './modules/rank'
import channel from './modules/channel'
import permission from './modules/permission'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // httpapi: "https://wechat3.walkerbang.com"
        httpapi: "https://wx.zngzc.com"
    },
    modules: {
        app,
        user,
        rank,
        permission,
        channel
    },
    getters
})

export default store